"<!-- ----------------------------------------------- -->
<template>
  <transition name="modal" appear>
    <div class="com-modal com-modal-overlay" @click.self="$emit('close')">
      <v-card class="com-pc-card no-gutters guide-dialog">
        <div>
          <v-row class="com-pc-card-header guide-header">
            <span class="com-pc-card-title"
              >{{ text.title }}{{ getSubTitle }}</span
            >
            <v-spacer></v-spacer>
            <v-btn
              icon
              dark
              small
              color="white"
              class="guide-btn"
              @click="$emit('close')"
            >
              <v-icon>highlight_off</v-icon>
            </v-btn>
          </v-row>
        </div>
        <v-col class="com-pc-card-contents guide-contents" ref="manualBox">
          <v-carousel v-model="page" show-arrows-on-hover :height="height">
            <v-carousel-item v-for="(guide, key) in pageList" :key="key">
              <v-sheet height="100%" tile v-if="imgDisp">
                <v-row
                  class="fill-height guide-color"
                  align="center"
                  justify="center"
                >
                  <img
                    v-if="guide.type == 'image'"
                    class="guide-img"
                    :src="`${guide.src}`"
                  />
                  <iframe
                    v-if="guide.type == 'html'"
                    class="guide-html"
                    :src="`${guide.src}`"
                  />
                  <pdf
                    v-if="guide.type == 'pdf'"
                    class="guide-pdf"
                    :src="`${guide.src}`"
                    :page="guide.number"
                  />
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-card>
    </div>
  </transition>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]操作説明ダイアログ
 * AppGuideDlg.vue
 * @author LIS
 */
import pdf from "vue-pdf";

export default {
  name: "app-guide-dlg",
  components: {
    pdf,
  },
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "操作説明 - ",
      },
      /** ウィンドウサイズ*/
      height: 0,
      /** 現在のページ番号 */
      page: 0,
      /** マニュアル情報 */
      titleList: null,
      pageList: null,
      /** 画像再表示用 */
      imgDisp: true,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeMount() {
    this.$log.debug("[AppGuide] beforeMount()");

    const path = location.pathname;
    const guideList = this.manualConfig;
    let def = null;
    for (let key in guideList) {
      let guide = guideList[key];
      const getQuery = Object.assign({}, this.$route.query);
      if (guide.path != "default") {
        if (
          path.startsWith(guide.path) &&
          guide.query &&
          guide.query.length > 0
        ) {
          let matchCnt = 0;
          guide.query.forEach((query) => {
            if (getQuery[query.name] == query.param) {
              matchCnt++;
            }
          });
          if (matchCnt == guide.query.length) {
            this.pageList = guide.page;
            break;
          }
        } else if (path.startsWith(guide.path)) {
          this.pageList = guide.page;
          break;
        }
      } else {
        def = guide;
      }
    }
    if (this.pageList == null) {
      this.pageList = def.page;
    }
    this.titleList = [];
    for (let key in this.pageList) {
      this.titleList.push(this.pageList[key].title);
    }
    this.$log.dir(this.pageList);
    this.$log.dir(this.titleList);
  },
  mounted() {
    this.handleResize();
    // 画像再表示
    this.imgDisp = false;
    setTimeout(() => {
      this.imgDisp = true;
    }, 100);
  },
  updated() {
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    manualConfig: {
      get() {
        let config = this.$store.state.app.config.manualConfig;
        return config.general.pc;
      },
    },
    getSubTitle: {
      get() {
        if (this.titleList != null) {
          return this.titleList[this.page];
        }
        return "";
      },
    },
  },
  methods: {
    handleResize() {
      this.$nextTick(() => {
        if (this.$refs.manualBox !== undefined) {
          this.$log.dir(this.$refs.manualBox);
          const offsetHeight = this.$refs.manualBox.offsetParent.offsetHeight;
          if (offsetHeight > 0) {
            this.height = offsetHeight - 16;
          }
          this.$log.debug("[AppGuide] height: " + this.height);
        }
      });
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.guide-dialog {
  width: 90%;
  height: 80%;
}

.guide-header {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.guide-btn {
  margin-top: -1px;
}

.guide-contents {
  border: 0;
  padding: 4px;
  background-color: lightskyblue;
}

.guide-color {
  background-color: lightskyblue;
}

.guide-img {
  border: 0;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}

.guide-html {
  border: 24px;
  width: 100vh;
  height: 100vh;
}

.guide-pdf {
  border: 1;
  width: auto;
  height: auto;
}
</style>
